import React, { useState, useEffect } from 'react';
import './ScrollToTopButton.css'; // You can style the button using CSS
import { IonIcon } from '../IonIcon';
import { getConfig } from 'config/config';

const { theme } = getConfig();

export const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.scrollY > 400) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div
      className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: theme.ICON_BACKGROUND, borderColor: theme.ICON_BORDER }}
      onClick={scrollToTop}
    >
      <IonIcon name="chevron-up" size={18} />
    </div>
  );
};
